module.exports = __webpack_public_path__ + "media/images/payments/americanexpress-3d72f390815161ff78d2140d8386f3f6.svg";